<div class="content">
    <div class="user-header">
        <nb-user [name]="null" size="large" [picture]="picture">
        </nb-user>
        <div class="user-info">
            <div class="name">
                <span>{{user.name}}</span>
            </div>
            <div class="role">
                <span>{{ role.toLowerCase() }}</span>
            </div>
            <div *ngIf="user.jobTitle" class="jobTitle">
                <span>{{ user.jobTitle ? user.jobTitle.value : '' }}</span>
            </div>
            <div class="email">
                <span data-test-id="logged-in-user-email">{{user.email}}</span>
            </div>
        </div>
    </div>
    <hr style="margin-top: 0; margin-bottom: 0;">
    <div class="options-container" *ngIf="showRolesButton">
        <mat-expansion-panel class="mat-elevation-z" *ngIf="availableRoles.length > 0">
            <mat-expansion-panel-header class="expand-header">
                <mat-panel-title>
                    Switch to role
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="roles-container">
                <div class="button-container" *ngFor="let role of availableRoles">
                    <div class="status-icon">
                        <mat-icon *ngIf="role.selected" class="icon-selected" nbTooltip="Selected Role"
                            nbTooltipStatus="success">done</mat-icon>
                        <!-- <mat-icon *ngIf="!role.selected && role.complete" class="icon-complete">radio_button_unchecked</mat-icon> -->
                        <mat-icon *ngIf="!role.selected && !role.complete" class="icon-incomplete"
                            (click)="changeRole(role.value)" nbTooltip="Incomplete Profile Information"
                            nbTooltipStatus="warning">warning_amber
                        </mat-icon>
                    </div>
                    <div class="select-button" [class.complete-role]="role.complete && !role.selected">
                        <button mat-button [class.selected-role]="role.selected" [disabled]="role.selected"
                            (click)="changeRole(role.value)">
                            {{role.value.replace('_',' ').toLowerCase()}}</button>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <button mat-button (click)="action('roles')" [disabled]="profileIncomplete">About Roles</button>
    </div>

    <hr style="margin-top: 0; margin-bottom: 0;" *ngIf="showRolesButton">
    <div class="options-container">
        <button mat-button (click)="action('profile')" [disabled]="profileIncomplete">Profile</button>
        <button mat-button (click)="action('change-password')">Change Password</button>
        <button mat-button (click)="action('signout')">Sign Out</button>
    </div>

</div>